import { Result } from 'domain/types';
import Location from 'domain/entity/location';
import ReadLocationsByHierarchyCriteria from 'use-case/locations/read/ReadLocationsByHierarchyCriteria';
import ReadLocationsByHierarchyClient from 'use-case/locations/read/ReadLocationsByHierarchyClient';

export type ReadLocationsByHierarchyResult = Result<Location>;
export type ReadLocationsByHierarchy = (criteria: ReadLocationsByHierarchyCriteria) => Promise<ReadLocationsByHierarchyResult>;

export default (getLocationsByHierarchyClient: ReadLocationsByHierarchyClient): ReadLocationsByHierarchy => (
    criteria: ReadLocationsByHierarchyCriteria
): Promise<ReadLocationsByHierarchyResult> => getLocationsByHierarchyClient(criteria);
